module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_7042.5b4a6b92.png";